


import {
  FaUser,
  FaTruck,
  FaWarehouse,
  FaBoxes,
  FaTags,
  FaClipboardList,
  FaTasks,
  FaChartBar,
  FaCheckCircle,
  FaThLarge,
  FaQuestionCircle
} from "react-icons/fa";

/**
 * Centralized icon registry
 * DB → Icon column must match these keys
 */
const ICON_MAP = {
  /* ADMIN */
  user: <FaUser color="#9c27b0" />,               // Purple – admin

  /* OPERATIONS */
  container: <FaTruck color="#ff9800" />,         // Orange – inbound
  warehouse: <FaWarehouse color="#2196f3" />,     // Blue – warehouse
  putaway: <FaBoxes color="#673ab7" />,            // Deep purple
  label: <FaTags color="#ff5722" />,               // Red-orange
  assign: <FaClipboardList color="#3f51b5" />,     // Indigo
  pick: <FaTasks color="#4caf50" />,               // Green – picking

  /* REPORTS */
  inventory: <FaChartBar color="#795548" />,       // Brown – inventory
  binned: <FaThLarge color="#607d8b" />,            // Blue-grey – racks/bins
  accepted: <FaCheckCircle color="#2e7d32" />,     // Dark green – success

  /* FALLBACK */
  default: <FaQuestionCircle color="#9e9e9e" />
};

export default ICON_MAP;
